import React, { useState } from 'react'
import styles from '../styles/AccordionSection.module.css'
import { IoChevronDown, IoChevronUp, IoAdd } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa6";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const AccordionSection = () => {

    const [activeIndex, setActiveIndex] = useState([]);

    const toggleAccordion = (index) => {
        if (activeIndex.includes(index)) {
            setActiveIndex(activeIndex.filter((item) => item !== index));
        } else {
            setActiveIndex([...activeIndex, index]);
        }
    };

    return (
        <div className={`${styles.accordion_section}`} id="faq-section">
            <div className={styles.header_container}>
                <h5>Any audience. Any size. Any scenario.</h5>
                <p>Create learning programs that drive engagement, productivity, advocacy, and impact  with your customers, partners, and employees.</p>
            </div>
            <div className={`${styles.signup_accordion} ${activeIndex.includes(0) ? styles.active : ""}`}>
                <div
                    onClick={() => toggleAccordion(0)}
                    className={styles.accordion_header}
                >
                    <span>What is Elmaam?</span>
                    {activeIndex.includes(0) ? <FaMinus /> : <FaPlus /> }
                </div>

                <div className={styles.accordion_content}>
                    <div className={styles.accordion_content_box}>
                        <p>Elmaam is a web and mobile enterprise learning and training management platform that helps organizations onboard, deliver interactive courses, and track learner progress for learning and compliance purposes.</p>
                    </div>
                </div>
            </div>

            <div className={`${styles.signup_accordion} ${activeIndex.includes(1) ? styles.active : ""}`}>
                <div
                    onClick={() => toggleAccordion(1)}
                    className={styles.accordion_header}
                >
                    <span>How do organizations onboard and get approved?</span>
                    {activeIndex.includes(1) ? <FaMinus /> : <FaPlus /> }
                </div>

                <div className={styles.accordion_content}>
                    <div className={styles.accordion_content_box}>
                        <p>Organizations can sign up and submit their details through the platform. After review, an admin approves the tenant. Once approved, employees from the organization can create accounts and access learning materials.</p>
                    </div>
                </div>
            </div>

            <div className={`${styles.signup_accordion} ${activeIndex.includes(2) ? styles.active : ""}`}>
                <div
                    onClick={() => toggleAccordion(2)}
                    className={styles.accordion_header}
                >
                    <span>What types of learning materials are available?</span>
                    {activeIndex.includes(2) ? <FaMinus /> : <FaPlus /> }
                </div>

                <div className={styles.accordion_content}>
                    <div className={styles.accordion_content_box}>
                        <p>The platform supports three main types of learning materials: Assessments, Communication, and Training. All courses are interactive and can include multimedia, quizzes, and assignments.</p>
                    </div>
                </div>
            </div>

            <div className={`${styles.signup_accordion} ${activeIndex.includes(3) ? styles.active : ""}`}>
                <div
                    onClick={() => toggleAccordion(3)}
                    className={styles.accordion_header}
                >
                    <span>Can employees access courses on mobile?</span>
                    {activeIndex.includes(3) ? <FaMinus /> : <FaPlus /> }
                </div>

                <div className={styles.accordion_content}>
                    <div className={styles.accordion_content_box}>
                        <p>Yes. Elmaam is built for both web and mobile access so learners can access courses anytime, anywhere using supported browsers or the mobile app where available.</p>
                    </div>
                </div>
            </div>

            <div className={`${styles.signup_accordion} ${activeIndex.includes(4) ? styles.active : ""}`}>
                <div
                    onClick={() => toggleAccordion(4)}
                    className={styles.accordion_header}
                >
                    <span>How can admins track progress and generate reports?</span>
                    {activeIndex.includes(4) ? <FaMinus /> : <FaPlus /> }
                </div>

                <div className={styles.accordion_content}>
                    <div className={styles.accordion_content_box}>
                        <p>Admins have dashboard tools to monitor user progress, view assignment statuses, and export reports. Real-time metrics help ensure compliance and measure learning impact.</p>
                    </div>
                </div>
            </div>

            <div className={`${styles.signup_accordion} ${activeIndex.includes(5) ? styles.active : ""}`}>
                <div
                    onClick={() => toggleAccordion(5)}
                    className={styles.accordion_header}
                >
                    <span>How does Elmaam support compliance?</span>
                    {activeIndex.includes(5) ? <FaMinus /> : <FaPlus /> }
                </div>

                <div className={styles.accordion_content}>
                    <div className={styles.accordion_content_box}>
                        <p>Elmaam helps organizations define required training paths, assign mandatory assessments, and generate compliance reports. Automated reminders and completion tracking ensure policies are met.</p>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default AccordionSection